import { useState, useEffect } from 'react';

export interface ChatConfigResponse {
  agent_name: string;
  agent_tagline: string;
  welcome_message: string;
  avatar_emoji: string;
  capabilities: string[];
  disclaimer_cowork: string;
  disclaimer_rag: string;
  data_classification: string;  // ← NEW: C1|C2|C3|C4
  agent_status_streaming?: boolean;
  show_usage_badge?: boolean;
}

const DEFAULT_CONFIG: ChatConfigResponse = {
  agent_name: 'Assistia',
  agent_tagline: 'Votre assistant documentaire',
  welcome_message: 'Bonjour ! Comment puis-je vous aider ?',
  avatar_emoji: '🤖',
  capabilities: ['rag', 'cowork'],
  disclaimer_cowork: 'Réponse générée par IA. Peut contenir des erreurs — vérifiez avant toute décision.',
  disclaimer_rag: 'Réponse basée sur vos documents. Vérifiez les pages référencées avant action.',
  data_classification: 'C3',
};

/**
 * Hook pour charger la configuration chat.
 * 
 * ⚠️ IMPORTANT : Fetch exécuté UNE SEULE FOIS au montage.
 * Le data_classification est stable pendant toute la session.
 * Pas de re-fetch au changement de token (gestionné via interceptor global).
 */
export function useChatConfig() {
  const [config, setConfig] = useState<ChatConfigResponse>(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // TABLEAU VIDE = EXÉCUTÉ UNE SEULE FOIS AU MOUNT
    // Token injecté automatiquement via l'interceptor HTTP global
    async function loadConfig() {
      try {
        const base = import.meta.env.VITE_API_BASE_URL ?? '';
        const response = await fetch(`${base}/api/v1/chat/config`, {
          headers: {
            'Content-Type': 'application/json',
            // Authorization géré par le wrapper HTTP global (ex: axios interceptor)
          },
        });
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const data = await response.json();
        setConfig(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    }
    
    loadConfig();
  }, []); // ← Vide = UNIQUE CALL
    
  return { config, loading, error };
}
